import script from "./publishModal.vue?vue&type=script&setup=true&lang=js"
export * from "./publishModal.vue?vue&type=script&setup=true&lang=js"

import "./publishModal.vue?vue&type=style&index=0&id=b35b1ad0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b35b1ad0"]])

export default __exports__